<div #personalInfo id="personalinfo">
  <div name="main" class="p-8 flex flex-col sm:w-auto bg-white">
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Lease Renewal</h2>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/4</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Contact Information</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/renewalcog/renewal-review/contact-info" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/4</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Other Occupant Information</h2>
          </div>
        </div>
      </div>
    </div>
    <form id="personalForm" #personalForm="ngForm" class="flex flex-col pt-8 md:px-16">
      <div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Occupants Under 18</mat-label>
            <mat-select name="HasOtherOccupants" id="HasOtherOccupants" required [(ngModel)]="model.HasOtherOccupants"
              (selectionChange)="forceAtLeastOneOccupant()" #HasOtherOccupants="ngModel">
              <mat-option *ngFor="let hasChildrenOption of hasOtherOccupantOptions" [value]="hasChildrenOption.value">
                {{hasChildrenOption.label}}
              </mat-option>
            </mat-select>
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <div id="children" class="md:pl-4">
          <div *ngFor="let occupant of model.OtherOccupants; let i = index; trackBy:listTrack">
            <div class="md:grid grid-cols-3" *ngIf="model.HasOtherOccupants">
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Guardian Name</mat-label>
                  <mat-select name="ResidentKey[{{i}}]" id="ResidentKey[{{i}}]" [options]="residents"
                    [disabled]="model.IsLocked" required [(ngModel)]="occupant.ResidentKey" #ResidentKey="ngModel">
                    <mat-option *ngFor="let resident of residents" [value]="resident.value">
                      {{resident.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div>
                <div class="md:px-2">
                  <mat-form-field class="w-full my-2">
                    <mat-label>Name</mat-label>
                    <input matInput name="Name[{{i}}]" id="Name[{{i}}]" required [(ngModel)]="occupant.Name"
                      #OccupantName="ngModel">
                    <mat-error>Please fill out this field</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Year Born</mat-label>
                  <mat-select name="BirthYear[{{i}}]" id="BirthYear[{{i}}]" required [(ngModel)]="occupant.BirthYear">
                    <mat-option *ngFor="let occupantBirthYear of occupantBirthYears" [value]="occupantBirthYear.value">
                      {{occupantBirthYear.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div>
                <button class="mb-3" mat-button color="accent" (click)="onRemoveOccupantClick(occupant)"
                  style="color: #545859">REMOVE</button>
              </div>
            </div>
          </div>
          <div *ngIf="model.HasOtherOccupants">
            <button class="mb-3" mat-button color="accent" (click)="onAddOccupantClick()" style="color: #545859">ADD
              ADDITIONAL UNDER
              18 OCCUPANT</button>
          </div>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Pet(s)</mat-label>
            <mat-select name="HasPets" id="HasPets" required [(ngModel)]="model.HasPets"
              (selectionChange)="forceAtLeastOnePet()" #HasPets="ngModel" [disabled]="true">
              <mat-option *ngFor="let hasPetOption of hasPetOptions" [value]="hasPetOption.value">
                {{hasPetOption.label}}
              </mat-option>
            </mat-select>
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <div id="pets" class="md:pl-4">
          <div *ngFor="let pet of model.Pets; let i = index; trackBy:listTrack">
            <div class="md:grid grid-cols-3" *ngIf="model.HasPets">
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Owner Name</mat-label>
                  <mat-select name="ResidentKey[{{i}}]" id="ResidentKey[{{i}}]" [options]="residents"
                    [disabled]="model.IsLocked" required [(ngModel)]="pet.ResidentKey" #ResidentKey="ngModel"
                    [disabled]="true">
                    <mat-option *ngFor="let resident of residents" [value]="resident.value">
                      {{resident.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Pet Type</mat-label>
                  <mat-select name="RentalPetTypesKey[{{i}}]" id="RentalPetTypesKey[{{i}}]" required
                    [(ngModel)]="pet.RentalPetTypesKey" [disabled]="true">
                    <mat-option *ngFor="let petType of petTypes" [value]="petType.value">
                      {{petType.label}}
                    </mat-option>
                  </mat-select>
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Breed</mat-label>
                  <input matInput name="Breed[{{i}}]" id="Breed[{{i}}]" required [(ngModel)]="pet.Breed"
                    #Breed="ngModel" [disabled]="true">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Name</mat-label>
                  <input matInput name="PetName[{{i}}]" id="PetName[{{i}}]" required [(ngModel)]="pet.PetName"
                    #PetName="ngModel" [disabled]="true">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Color</mat-label>
                  <input matInput name="Color[{{i}}]" id="Color[{{i}}]" required [(ngModel)]="pet.Color"
                    #Color="ngModel" [disabled]="true">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-form-field class="w-full my-2">
                  <mat-label>Weight</mat-label>
                  <input matInput name="Weight[{{i}}]" id="Weight[{{i}}]" required [(ngModel)]="pet.Weight"
                    #Weight="ngModel" [disabled]="true">
                  <mat-error>Please fill out this field</mat-error>
                </mat-form-field>
              </div>
              <div class="md:px-2">
                <mat-checkbox class="my-2" matInput name="IsServiceAnimal[{{i}}]" id="IsServiceAnimal[{{i}}]"
                  [(ngModel)]="pet.IsServiceAnimal" #IsServiceAnimal="ngModel" [disabled]="true">Service
                  Animal?</mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button *ngIf="!model.IsLocked" mat-flat-button color="primary" class="h-10 px-6 my-2"
          (click)="removeUnusedOccupantsAndPets()" [disabled]="!personalForm.form.valid">CONTINUE</button>
        <button *ngIf="model.IsLocked" mat-flat-button color="primary" class="h-10 px-6 my-2"
          (click)="onUpdateSuccess()">CONTINUE</button>
      </div>
    </form>
  </div>
</div>
